module.exports = __webpack_public_path__ + "media/images/favicon-c65e5eb40c3c44568530f5cfb18abf9a.ico";